module.exports = __webpack_public_path__ + "static/media/Slowbro_gaussian2.ca629c77.png";